module.exports = __webpack_public_path__ + "fonts/BrandonText-Bold.89fdab2e.otf";